import React from "react";
import { LegalLayout, H2, P, UL } from "./LegalLayout";

export default function LegalNoticePage() {
  return (
    <LegalLayout testid="legal-notice-page" title="Legal Notice" lastUpdated="February 1, 2026">
      <P>
        In accordance with applicable consumer protection and e-commerce regulations, this
        Legal Notice provides identification of the operator of the Site{" "}
        <strong>simplestylemode.com</strong> (the "Site") and defines its editorial and hosting
        responsibility.
      </P>

      <H2>1. Site operator</H2>
      <UL>
        <li><strong>Company name:</strong> ULTRANEQ LLC</li>
        <li><strong>Legal form:</strong> Limited Liability Company (LLC)</li>
        <li><strong>Brand name (DBA):</strong> Simple Style Mode</li>
        <li><strong>Business activity:</strong> Online retail of apparel and accessories</li>
        <li><strong>Registered address:</strong> 2105 Vista Oeste NW, Albuquerque, NM 87120, United States</li>
        <li><strong>Email:</strong> support@simplestylemode.com</li>
        <li><strong>Jurisdiction of registration:</strong> State of New Mexico, United States</li>
      </UL>

      <H2>2. Publication director</H2>
      <P>
        The person responsible for publication is the appointed representative of ULTRANEQ
        LLC. Editorial responsibility covers all content visible on the Site, including
        product descriptions, imagery, and editorial copy.
      </P>

      <H2>3. Hosting</H2>
      <P>
        The Site is hosted by professional cloud-hosting providers located in the United
        States and the European Union. For any technical request concerning hosting, please
        contact us at{" "}
        <a href="mailto:support@simplestylemode.com" className="underline">support@simplestylemode.com</a>{" "}
        and we will route your request accordingly.
      </P>

      <H2>4. Intellectual property</H2>
      <P>
        All elements of the Site — including the brand name "Simple Style Mode", the logo,
        product photography, text, graphics, and overall design — are the exclusive property
        of ULTRANEQ LLC unless otherwise stated. Any reproduction, representation, modification,
        publication, transmission or distortion, in whole or in part, is strictly prohibited
        without our prior written consent.
      </P>

      <H2>5. Product authenticity</H2>
      <P>
        All Products sold on the Site are unbranded or sold under the own brand "Simple Style
        Mode". We do not sell replicas, counterfeit goods, or licensed third-party products.
        Our garments are designed in-house and produced in small batches.
      </P>

      <H2>6. Liability</H2>
      <P>
        ULTRANEQ LLC strives to provide accurate and up-to-date information on the Site. We
        cannot however guarantee the absence of errors or omissions. The Site may include
        links to external websites for which we do not assume any responsibility. Access to
        the Site may be temporarily suspended for maintenance without prior notice.
      </P>

      <H2>7. Applicable law</H2>
      <P>
        This Legal Notice is governed by the laws of the State of New Mexico, United States,
        without prejudice to any mandatory consumer protection rules of the Customer's
        country of residence.
      </P>

      <H2>8. Contact</H2>
      <P>
        For any question concerning this Legal Notice, please contact us at{" "}
        <a href="mailto:support@simplestylemode.com" className="underline">support@simplestylemode.com</a>.
      </P>
    </LegalLayout>
  );
}
